"use client";

import { c as _c } from "react/compiler-runtime";
import { CommentForm } from "@/components/Comment/components/form/CommentForm.component";
import { LoginPrompt } from "@/components/Comment/components/prompts/LoginPrompt.component";
import { NameMissingPrompt } from "@/components/Comment/components/prompts/NameMissingPrompt.component";
import { useComments } from "@/components/Comment/context/comments.context";
import { Translation } from "@/components/Translation/Translation.component";
import { useSite } from "@/contexts/site/site.context";
export function CommentFormSection() {
  const $ = _c(10);
  const {
    hasActiveSubscription,
    isLoggedIn,
    isClosed,
    hasValidUserName
  } = useComments();
  const {
    name
  } = useSite();
  if (isClosed) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="bg-silent py-4 text-left font-medium text-dim text-sm md:py-2"><Translation da="Kommentarsporet er lukket." de="Die Kommentarfunktion ist geschlossen." en="The comment section is closed." no="Kommentarfeltet er stengt." sv={"Kommentarsf\xE4ltet \xE4r st\xE4ngt."} /></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (!isLoggedIn) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <LoginPrompt />;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  if (!hasValidUserName && hasActiveSubscription) {
    let t0;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <NameMissingPrompt />;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  if (!hasActiveSubscription) {
    const t0 = `Du skal abonnere på ${name} for at kunne kommentere.`;
    const t1 = `Sie müssen ${name} abonnieren, um kommentieren zu können.`;
    const t2 = `You must subscribe to ${name} to comment.`;
    const t3 = `Du må abonnere på ${name} for å kunne kommentere.`;
    const t4 = `Du måste prenumerera på ${name} för att kunna kommentera.`;
    let t5;
    if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
      t5 = <div className="bg-silent py-4 text-left font-medium text-dim text-sm md:py-2"><Translation da={t0} de={t1} en={t2} no={t3} sv={t4} /></div>;
      $[3] = t0;
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t0;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CommentForm />;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  return t0;
}